import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = process.env.REACT_APP_BASE_URL || 'https://api.careerroshi.com' 

export const GetFilterJobSeeker = async ( filter ) => {
    const res = await axios.post(`${URL}/report/get`, filter)
    return res.data;
}

export const GetSavedFilters = async ( userId , search ,type = 'ORGANIZATION' ) => {
    const res = await axios.get(`${URL}/report/saved-filter/get`, {
        params: {
            userId,
            type,
            search
        }
    })
    return res.data;
}

export const GetCoachesByOrgId = async (orgId, search = '') => {
    const res = await axios.get(`${URL}/organization/coaches/${orgId}`, {
        params: {
            type: "ORGANIZATION",
            search
        }
    })
    return res.data;
}

export const DeleteFilter = async (id) => {
    const res = await axios.delete(`${URL}/report/saved-filter/${id}`);
    return res.data
}

export const GetOccupationList = async (name)=>{
    const res = await axios.get(`${URL}/occupation/interest/list`, {
        params: {
            search: name
        }
    })
    return res.data;
}
export const UpdateFilter = async ( filter ) => {
    const res = await axios.post(`${URL}/report/filter/update`, filter)
    return res.data;
}
export const GetSaveFilter = async ( id ) => {
    const res = await axios.get(`${URL}/report/filter/${id}`)
    return res.data;
}

export const SaveFilter = async ( filter ) => {
    const res = await axios.post(`${URL}/report/filter/save`, filter)
    return res.data;
}
export const DeleteSavedFilter = async (id) => {
    const res = await axios.delete(`${URL}/report/saved-filter/${id}`);
    return res.data
}

export const GetJobSeekerByOrgID = async (orgId, search = '') => {
    const res = await axios.get(`${URL}/organization/jobseekers/${orgId}`, {
        params: {
            type: "ORGANIZATION",
            search
        }
    })
    return res.data;
}

export const GetUserDetails = async (org_id, name)=>{
    const res = await axios.get(`${URL}/organization/jobseeker/user/source/platform`, {
        params: {
            search: name,
            org_id
        }
    })
    return res.data;
}